import React from 'react';

const WellTestingInfoModal = ({ isOpen, onClose, setActiveTab }) => {
  if (!isOpen) return null;

  const handleOptionClick = (tab) => {
    setActiveTab(tab);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-6 border w-[600px] shadow-lg rounded-md bg-white">
        <div className="mt-2">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Well Testing Data Collection</h2>
          
          <div className="space-y-6 text-gray-700">
            <div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">About Our Project</h3>
              <p className="leading-relaxed">
                We are gathering data about well testing results in Western North Carolina 
                and Eastern Tennessee to build a comprehensive database of water quality information.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">How You Can Contribute</h3>
              <div className="space-y-3 ml-4">
                <div 
                  className="flex items-start cursor-pointer hover:bg-blue-50 p-2 rounded-lg transition-colors"
                  onClick={() => handleOptionClick('map')}
                >
                  <div className="flex-shrink-0 h-5 w-5 relative top-0.5">
                    <div className="absolute inset-0 rounded-full bg-blue-500"></div>
                    <div className="absolute inset-1 rounded-full bg-white"></div>
                  </div>
                  <p className="ml-3">
                    <span className="font-medium">Structured Data:</span> If you already have structured data (with addresses) for multiple well tests, 
                    you can preview them in our interactive map visualization and add it to our database.
                  </p>
                </div>
                <div 
                  className="flex items-start cursor-pointer hover:bg-blue-50 p-2 rounded-lg transition-colors"
                  onClick={() => handleOptionClick('upload')}
                >
                  <div className="flex-shrink-0 h-5 w-5 relative top-0.5">
                    <div className="absolute inset-0 rounded-full bg-blue-500"></div>
                    <div className="absolute inset-1 rounded-full bg-white"></div>
                  </div>
                  <p className="ml-3">
                    <span className="font-medium">Individual Results:</span> If you have the results from a single test, you can upload them 
                    and we'll convert them to structured data for the database.
                  </p>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Accepted File Types</h3>
              <p className="leading-relaxed">
                We accept the following formats:
              </p>
              <ul className="list-disc ml-6 mt-2 space-y-1">
                <li>PDF documents</li>
                <li>Photos of test results</li>
                <li>Spreadsheet files</li>
              </ul>
            </div>
          </div>

          <div className="mt-8 flex justify-center">
            <button
              onClick={onClose}
              className="px-6 py-2 bg-blue-500 text-white text-base font-medium rounded-md shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300 transition-colors"
            >
              Got it
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WellTestingInfoModal;
